<!-- Generated by AIG Copilot - start -->
@if (baseRules?.hasOutstanding && !isReviewPage) {
  <h2 class="axis-h4">Hawaii</h2>
  @if (reactiveForm) {
    <form [formGroup]="reactiveForm">
      <h3 class="axis-h5">UM Coverage:</h3>
      <!--Uninsured level one radio-->
      <div
        class="axis-form-group _mt-medium"
        [ngClass]="{
          'has-axis-required': reactiveForm.get(controls[0].formControlName)?.value === null,
          'has-axis-error':
            reactiveForm.get(controls[0].formControlName)?.touched &&
            reactiveForm.get(controls[0].formControlName)?.invalid,
        }"
      >
        @if (controls?.length >= 1) {
          <axis-radio-button-wrapper formControlName="{{ controls[0].formControlName }}">
            @for (control of controls[0].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[0].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[0].formControlName)?.touched) {
            @if (reactiveForm.get(controls[0].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        }
      </div>
      <!--Uninsured level two Radio-->
      <div
        class="axis-form-group _mt-medium"
        [ngClass]="{
          'has-axis-required': reactiveForm.get(controls[1].formControlName)?.value === null,
          'has-axis-error':
            reactiveForm.get(controls[1].formControlName)?.touched &&
            reactiveForm.get(controls[1].formControlName)?.invalid,
        }"
      >
        @if (controls?.length >= 1) {
          <axis-radio-button-wrapper formControlName="{{ controls[1].formControlName }}">
            @for (control of controls[1].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                heading="{{ control.label }}"
                class="{{ control.class }}"
                value="{{ control.select }}"
                name="{{ controls[1].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[1].formControlName)?.touched) {
            @if (reactiveForm.get(controls[1].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        }
      </div>
      <!--Uninsured dropdowns-->
      @let uSel = reactiveForm?.get(controls[0].formControlName)?.value;
      @let uKey = uSel?.value ?? uSel?.select ?? uSel;

      <div class="axis-grid">
        @for (control of controls | slice: 2 : 6; track $index) {
          @if (baseRules[control.baseRuleKey]?.includes("show")) {
            <div class="axis-col-sm-6 axis-col-md-6">
              <div
                class="axis-form-group"
                [ngClass]="{
                  'has-axis-required':
                    reactiveForm.get(control.formControlName)?.value === null ||
                    reactiveForm.get(control.formControlName)?.value === '',
                  'has-axis-error':
                    reactiveForm.get(control.formControlName)?.touched &&
                    reactiveForm.get(control.formControlName)?.invalid,
                }"
              >
                <label
                  class="axis-control-label"
                  for="{{ control.formControlName }}"
                  >{{ control.label }}
                  <span
                    aria-hidden="true"
                    class="axis-required-indicator"
                    >*</span
                  >
                </label>
                <axis-dropdown
                  [dataProvider]="control.data"
                  id="{{ control.formControlName }}"
                  formControlName="{{ control.formControlName }}"
                  (onSelect)="
                    control.selectedPremium =
                      uKey === 'SelectStacked_LevelOne_Uninsured_Radio'
                        ? $any($event).stackedPremium
                        : uKey === 'SelectNonStacked_LevelOne_Uninsured_Radio'
                          ? $any($event).nonStackedPremium
                          : null;
                          handleDropdownSelection(control, $event);
                  "
                ></axis-dropdown>
                @if (reactiveForm.get(control.formControlName)?.touched) {
                  @if (reactiveForm.get(control.formControlName)?.invalid) {
                    <span
                      class="axis-error-block"
                      role="alert"
                      >Please select an option.</span
                    >
                  }
                }
                @if (control.selectedPremium) {
                  <div [hidden]="!showPremium">Premium Per Vehicle: {{ control.selectedPremium }}</div>
                }
              </div>
            </div>
          }
        }
      </div>
      <!-- Uninsured readonly dropdown — Split Min -->
      @let umSplit = reactiveForm?.get(controls[0].formControlName)?.value;
      @let umSplitKey = umSplit?.value ?? umSplit?.select ?? umSplit;

      @if (
        (umSplitKey === "SelectStacked_LevelOne_Uninsured_Radio" ||
          umSplitKey === "SelectNonStacked_LevelOne_Uninsured_Radio") &&
        (baseRules?.["SplitMin_Uninsured_DropDown"] || "").includes("readonly")
      ) {
        <div class="axis-grid">
          <div class="axis-col-sm-6 axis-col-lg-4">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[4].label }}</label>
              <div id="splitmin_uninsured_40k_80k-pdffield-hawaii">{{ controls[4].data[0].name }}</div>
            </div>
          </div>
        </div>
      }

      <!-- Uninsured readonly dropdown — Combined Single limit -->
      @let umCombined = reactiveForm?.get(controls[0].formControlName)?.value;
      @let umCombinedKey = umCombined?.value ?? umCombined?.select ?? umCombined;

      @if (
        (umCombinedKey === "SelectStacked_LevelOne_Uninsured_Radio" ||
          umCombinedKey === "SelectNonStacked_LevelOne_Uninsured_Radio") &&
        (baseRules?.["CombinedSingleLimitMin_Uninsured_DropDown"] || "").includes("readonly")
      ) {
        <div class="axis-grid">
          <div class="axis-col-sm-6 axis-col-lg-4">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[5].label }}</label>
              <div id="combinedsinglelimitmin_uninsured_80k-pdffield-hawaii">{{ controls[5].data[0].name }}</div>
            </div>
          </div>
        </div>
      }

      <!-- Uninsured readonly dropdown — Liability Limit -->
       @if (
        (umCombinedKey === "SelectStacked_LevelOne_Uninsured_Radio" ||
          umCombinedKey === "SelectNonStacked_LevelOne_Uninsured_Radio") &&
        (baseRules?.["UM_LiabilityLimit_DropDown"] || "").includes("readonly")
      ) {
        <div class="axis-grid">
          <div class="axis-col-sm-6 axis-col-lg-4">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[12].label }}</label>
              <div id="um_liabilitylimit_Limit_equal_to_the_limit_of_my_Bodily_Injury_Liability_Coverage-pdffield-hawaii">{{ controls[12].data[0].name }}</div>
            </div>
          </div>
        </div>
      }
      <h3 class="axis-h5 _mt">UIM Coverage:</h3>
      <!--Underinsured level one radio-->
      <div
        class="axis-form-group _mt-medium"
        [ngClass]="{
          'has-axis-required': reactiveForm.get(controls[6].formControlName)?.value === null,
          'has-axis-error':
            reactiveForm.get(controls[6].formControlName)?.touched &&
            reactiveForm.get(controls[6].formControlName)?.invalid,
        }"
      >
        @if (controls?.length >= 6) {
          <axis-radio-button-wrapper formControlName="{{ controls[6].formControlName }}">
            @for (control of controls[6].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                class="{{ control.class }}"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[6].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[6].formControlName)?.touched) {
            @if (reactiveForm.get(controls[6].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        }
      </div>

      <!--Underinsured Level two radio-->
      <div
        class="axis-form-group _mt-medium"
        [ngClass]="{
          'has-axis-required': reactiveForm.get(controls[7].formControlName)?.value === null,
          'has-axis-error':
            reactiveForm.get(controls[7].formControlName)?.touched &&
            reactiveForm.get(controls[7].formControlName)?.invalid,
        }"
      >
        @if (controls?.length >= 2) {
          <axis-radio-button-wrapper formControlName="{{ controls[7].formControlName }}">
            @for (control of controls[7].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                class="{{ control.class }}"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[7].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[7].formControlName)?.touched) {
            @if (reactiveForm.get(controls[7].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        }
      </div>
      <!--Underinsured dropdowns-->
      @let uimSel = reactiveForm?.get(controls[6].formControlName)?.value;
      @let uimKey = uimSel?.value ?? uimSel?.select ?? uimSel;

      <div class="axis-grid">
        @for (control of controls | slice: 8; track $index) {
          @if (baseRules[control.baseRuleKey]?.includes("show")) {
            <div class="axis-col-sm-6 axis-col-md-6">
              <div
                class="axis-form-group"
                [ngClass]="{
                  'has-axis-required':
                    reactiveForm.get(control.formControlName)?.value === null ||
                    reactiveForm.get(control.formControlName)?.value === '',
                  'has-axis-error':
                    reactiveForm.get(control.formControlName)?.touched &&
                    reactiveForm.get(control.formControlName)?.invalid,
                }"
              >
                <label
                  class="axis-control-label"
                  for="{{ control.formControlName }}"
                  >{{ control.label }}
                  <span
                    aria-hidden="true"
                    class="axis-required-indicator"
                    >*</span
                  >
                </label>
                <axis-dropdown
                  [dataProvider]="control.data"
                  id="{{ control.formControlName }}"
                  formControlName="{{ control.formControlName }}"
                  (onSelect)="
                    control.selectedPremium =
                      uimKey === 'SelectStacked_LevelOne_UnderInsured_Radio'
                        ? $any($event).stackedPremium
                        : uimKey === 'SelectNonStacked_LevelOne_UnderInsured_Radio'
                          ? $any($event).nonStackedPremium
                          : null;
                          handleDropdownSelection(control, $event);
                  "
                ></axis-dropdown>
                @if (reactiveForm.get(control.formControlName)?.touched) {
                  @if (reactiveForm.get(control.formControlName)?.invalid) {
                    <span
                      class="axis-error-block"
                      role="alert"
                      >Please select an option.</span
                    >
                  }
                }
                @if (control.selectedPremium) {
                  <div [hidden]="!showPremium">Premium Per Vehicle: {{ control.selectedPremium }}</div>
                }
              </div>
            </div>
          }
        }
      </div>

      <!-- Underinsured readonly dropdown — Split Min -->
      @let uimSplit = reactiveForm?.get(controls[6].formControlName)?.value;
      @let uimSplitKey = uimSplit?.value ?? uimSplit?.select ?? uimSplit;

      @if (
        (uimSplitKey === "SelectStacked_LevelOne_UnderInsured_Radio" ||
          uimSplitKey === "SelectNonStacked_LevelOne_UnderInsured_Radio") &&
        (baseRules?.["SplitMin_UnderInsured_DropDown"] || "").includes("readonly")
      ) {
        <div class="axis-grid">
          <div class="axis-col-sm-6 axis-col-lg-4">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[10].label }}</label>
              <div id="splitmin_underinsured_40k_80k-pdffield-hawaii">{{ controls[10].data[0].name }}</div>
            </div>
          </div>
        </div>
      }

      <!-- Underinsured readonly dropdown — Combined Single limit -->
      @let uimCombined = reactiveForm?.get(controls[6].formControlName)?.value;
      @let uimCombinedKey = uimCombined?.value ?? uimCombined?.select ?? uimCombined;

      @if (
        (uimCombinedKey === "SelectStacked_LevelOne_UnderInsured_Radio" ||
          uimCombinedKey === "SelectNonStacked_LevelOne_UnderInsured_Radio") &&
        (baseRules?.["CombinedSingleLimitMin_UnderInsured_DropDown"] || "").includes("readonly")
      ) {
        <div class="axis-grid">
          <div class="axis-col-sm-6 axis-col-lg-4">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[11].label }}</label>
              <div id="combinedsinglelimitmin_underinsured_80k-pdffield-hawaii">{{ controls[11].data[0].name }}</div>
            </div>
          </div>
        </div>
      }
      <!-- Underinsured readonly dropdown — Liability Limit -->
      @if (
        (uimCombinedKey === "SelectStacked_LevelOne_UnderInsured_Radio" ||
          uimCombinedKey === "SelectNonStacked_LevelOne_UnderInsured_Radio") &&
        (baseRules?.["UIM_LiabilityLimit_DropDown"] || "").includes("readonly")
      ) {
        <div class="axis-grid">
          <div class="axis-col-sm-6 axis-col-lg-4">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[13].label }}</label>
              <div id="uim_liabilitylimit_Limit_equal_to_the_limit_of_my_Bodily_Injury_Liability_Coverage-pdffield-hawaii">{{ controls[13].data[0].name }}</div>
            </div>
          </div>
        </div>
      }
    </form>
    <p>{{ textValues?.description }}</p>
  }
}
@if (baseRules && !baseRules?.hasOutstanding && isReviewPage) {
  <h2 class="axis-h4">Hawaii</h2>
  @if (baseRules?.Reject_LevelOne_Uninsured_Radio) {
    <div class="axis-form-group">
      <label class="axis-control-label"> {{ textValues?.Reject_Uninsured_Text }} </label>
    </div>
  }
  @if (baseRules?.Reject_LevelOne_UnderInsured_Radio) {
    <div class="axis-form-group">
      <label class="axis-control-label"> {{ textValues?.Reject_UnderInsured_Text }} </label>
    </div>
  }

  <div class="axis-grid">
    @if (baseRules.BISplitMinLimits_DropDown) {
      <div class="axis-col-sm-6 axis-col-lg-4">
        <div class="axis-form-group">
          <label class="axis-control-label">{{ controls[12].label }} </label>
          <div>{{ controls[12].data[0].name }}</div>
        </div>
      </div>
    }
    @if (baseRules.BICombinedMinSingleLimit_DropDown) {
      <div class="axis-col-sm-6 axis-col-lg-4">
        <div class="axis-form-group">
          <label class="axis-control-label"> {{ controls[9].label }} </label>
          <div>{{ controls[9].data[0].name }}</div>
        </div>
      </div>
    }
  </div>
}
